import { DialogResponse } from 'owa-confirm-dialog';
import { updateUserConfiguration } from 'owa-options-core';
import deleteFullSearchHistoryFromRestOperation from 'owa-service/lib/operation/deleteFullSearchHistoryFromRestOperation';
import { action, mutator } from 'satcheljs';
import { getUserConfiguration } from 'owa-session-store';
import OwaUserConfiguration from 'owa-service/lib/contract/OwaUserConfiguration';

interface ClearSearchHistoryActionMessage {
    dialogResponse: DialogResponse;
    userConfig: OwaUserConfiguration;
}

let clearSearchHistory = action(
    'clearSearchHistory',
    (response: DialogResponse): ClearSearchHistoryActionMessage => {
        return {
            dialogResponse: response,
            userConfig: getUserConfiguration(),
        };
    }
);

mutator(clearSearchHistory, (actionMessage: ClearSearchHistoryActionMessage) => {
    if (actionMessage.dialogResponse === DialogResponse.ok) {
        // Issue a request to the DeleteFullSearchHistoryFromRest OWS API, but ignore
        // the result, since we can update ours anyway.
        deleteFullSearchHistoryFromRestOperation({});

        if (actionMessage.userConfig.ViewStateConfiguration) {
            actionMessage.userConfig.ViewStateConfiguration.SearchHistory = [];
        }

        updateUserConfiguration(
            [
                {
                    propertyName: 'SearchHistory',
                    propertyType: 'StringArray',
                    propertyValue: [],
                },
            ],
            'OWA.ViewStateConfiguration'
        );
    }
});

export default clearSearchHistory;
export { ClearSearchHistoryActionMessage };
